import React, { useEffect, useState } from 'react'
import FinancePartnerModel from './models/FinancePartnerModel'

function DeleteFinancePartner({ FinancePartnerData }) {
  const [deleteFinancePartner, setDeleteFinancePartner] = useState(new FinancePartnerModel() || [])

  useEffect(() => {
    setDeleteFinancePartner(FinancePartnerData)
  }, [FinancePartnerData])

  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following Finance Partner will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Finance Partner :</b> {deleteFinancePartner.FinancePartnerName}</li>
            <li><b>Interest Rate :</b> {deleteFinancePartner.InterestRate}</li>
            <li><b>Minimum Down Payment :</b> {deleteFinancePartner.MinimumDownPayment}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteFinancePartnerDetails" hidden>{JSON.stringify(deleteFinancePartner)}</div>
    </>
  )
}

export default DeleteFinancePartner
